// A Route's display name is the route record's own name — decoupled from the
// name of the Connection that provides its data. Older Routes may have no
// route record (default_route: null with an empty routing_rules), so fall
// back to the provider's name rather than rendering blank.
export const routeDisplayName = (route: any): string =>
    route?.default_route?.name
    || route?.routing_rules?.[0]?.name
    || route?.provider?.name
    || "";

// A Route's own record id — what /v2/routes/ and every /routes/... URL address.
// Older connections can report `default_route: null` while still carrying the
// record in `routing_rules` (seen on stage), so both are checked. Returns
// undefined when the connection has no record at all: callers that need an id
// for a route-record API call must not fall back to the provider integration's
// id, which belongs to a different id space and 404s on /v2/routes/.
export const routeRecordId = (route: any): string | undefined =>
    route?.default_route?.id || route?.routing_rules?.[0]?.id || undefined;
